
import Events from "views/Eventos/Events";
import AcademicReinforcement from "views/RefuerzoAcademico/AcademicReinforcement";
import Appointment from "views/Asesorias/Appointment";
import Settings from "views/Configuracion/Settings";
import Resources from "views/Recursos/Resources";
import { MODULE_VIEWS } from "config/userPermissions";

export const VIEWS = {
    [MODULE_VIEWS.EVENTOS]: <Events/>,
    [MODULE_VIEWS.REF_ACAD]: <AcademicReinforcement/>,
    [MODULE_VIEWS.ASESORIAS]: <Appointment/>,
    [MODULE_VIEWS.RECURSOS]: <Resources/>,
    [MODULE_VIEWS.CONFIG]: <Settings/>
};